// toggle header init
export default function initHeaderSticky() {
  const body = document.body;
  const headerFixed = 'header-fixed';
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;

    if (currentScroll > headerHeight) {
      if (!body.classList.contains(headerFixed)) {
        body.classList.add(headerFixed);
      }
    } else {
      body.classList.remove(headerFixed);
    }
  });
}
